
function metaTypeToFilterType(input) {
  const mapped = {
    currency: 'range',
    int: 'range',
    double: 'range',
    percent: 'range',
    number: 'range',
    formula: 'range',
    boolean: 'picklist',
    date: 'daterange',
    datetime: 'daterange',
    textarea: 'string',
    // string: 'string',
    // email: 'string',
  };

  return mapped[input] || 'multipicklist';
}

function translateMetaToFilter(meta, searchPath) {
  const id = searchPath.join('/');
  const metaType = id === 'Gong__Gong_Call__c/Gong__Opp_Stage_Time_Of_Call__c' ? 'picklist' : meta.type;
  const f = {
    _id: id,
    filter_id: id,
    values: [],
    mappings: [],
    // $can_add_mapping: meta.type === 'multipicklist' || meta.type === 'reference',
    is_boolean: metaType === 'boolean',
    meta: {
      type: metaType,
    },
    type: metaTypeToFilterType(metaType),
    is_system_filter: true,
    search_paths: searchPath,
    label: meta.label,
    name: meta.name,
    description: meta.description,
    is_dynamic: true,
    // $fieldMetaType: meta && (meta.type === 'string' || meta.type === 'email') ? 'string' : (meta ? meta.type : null),
    $fieldMetaType: meta ? metaType : null,
  };
  return f;
}

module.exports = {
  translateMetaToFilter,
  metaTypeToFilterType,
};
